<div class="col-12">
  <!-- aporto tasacion -->

  <div class="primary-info-box" [ngClass]="{ disabled: status >= minStatus.appraisal_done }">
    <p class="info-text">
      {{ 'appraisal_form_has_appraisal_title' | translate }}
      <a class="icon-a" (click)="openModal('appraisal')" id="appraisal-from-has-simple-note-info">
        <img class="ico-info" src="assets/img/info.png" />
      </a>
    </p>
    <div class="row date-row w-switch">
      <hr class="divider" />
      <div class="col-lg-3 col-sm-4 col-6 input-top-reset">
        <label>{{ 'appraisal_form_has_appraisal' | translate }}</label>
      </div>
      <div class="switch-group col-lg-3 col-sm-2 col-6 no-pd input-top-reset">
        <label class="switch" id="appraisal-from-label-has-simple-note">
          <input
            [disabled]="status >= minStatus.appraisal_done"
            [(ngModel)]="hasAppraisal"
            (change)="hasAppraisalChanged()"
            type="checkbox"
          />
          <span class="slider round">
            <span> {{ 'yes' | translate }} </span>
            <span> {{ 'no' | translate }} </span>
          </span>
        </label>
      </div>

      @if (hasAppraisal) {
        <div class="col-lg-6 col-sm-6 col-12 input-top-reset">
          <a
            id="appraisal-from-upload-simple-note"
            class="animated fadeIn btn btn-02 btn-add"
            href="javascript:;"
            (click)="openModalUpload()"
            >{{ 'appraisal_form_upload_appraisal' | translate }}</a
          >
        </div>
      }
    </div>
  </div>

  <div class="primary-info-box">
    @if (status < minStatus.appraisal_done) {
      <div>
        <form
          class="row get-appraisal"
          [formGroup]="appraisalForm"
          (ngSubmit)="submitAppraisalForm(appraisalForm.valid, appraisalForm.value)"
        >
          <div class="col-12">
            <h2 class="h-main h-main-medium">
              {{ 'appraisal_form_request_appraisal' | translate }}
            </h2>
          </div>
          <p class="col-12 info-text">
            {{ 'appraisal_form_address_appraisal' | translate }}
          </p>
          <div class="col-md-6 col-12">
            <div class="input-box">
              <label
                for="appraisal-form-streetType"
                [class.has-error]="
                  (appraisalForm?.controls)['streetType']?.touched && !(appraisalForm?.controls)['streetType'].valid
                "
                >{{ 'appraisal_form_street_type' | translate }}</label
              >
              <select id="appraisal-form-streetType" formControlName="streetType">
                <option *ngFor="let roadType of listRoadType$ | async" [value]="roadType?.code">
                  {{ roadType?.description | translate }}
                </option>
              </select>
              <div class="error-content">
                @if (
                  (appraisalForm?.controls)['streetType'].touched &&
                  appraisalForm?.controls['streetType'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="input-box">
                  <label
                    for="appraisal-form-number"
                    [class.has-error]="
                      (appraisalForm?.controls)['number']?.touched && !(appraisalForm?.controls)['number'].valid
                    "
                    >{{ 'appraisal_form_number' | translate }}</label
                  >
                  <input
                    id="appraisal-form-number"
                    type="text"
                    formControlName="number"
                    [maxlength]="HTML_VALIDATORS?.maxLength?.roadNumber"
                  />
                  <div class="error-content">
                    @if ((appraisalForm?.controls)['number'].touched && (appraisalForm?.controls)['number'].invalid) {
                      <p class="has-error">
                        {{ 'appraisal_form_invalid_number' | translate }}
                      </p>
                    }
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="input-box">
                  <label
                    for="appraisal-form-flat"
                    [class.has-error]="
                      (appraisalForm?.controls)['flat']?.touched && !(appraisalForm?.controls)['flat'].valid
                    "
                    >{{ 'appraisal_form_flat' | translate }}</label
                  >
                  <input
                    id="appraisal-form-flat"
                    type="text"
                    formControlName="flat"
                    [maxlength]="HTML_VALIDATORS?.maxLength?.floor"
                  />
                  <div class="error-content">
                    @if ((appraisalForm?.controls)['flat'].touched && (appraisalForm?.controls)['flat'].invalid) {
                      <p class="has-error">
                        {{ 'appraisal_form_invalid_flat' | translate }}
                      </p>
                    }
                  </div>
                </div>
              </div>
              <div class="col-4">
                <div class="input-box">
                  <label
                    for="appraisal-form-door"
                    [class.has-error]="
                      (appraisalForm?.controls)['door']?.touched && !(appraisalForm?.controls)['door'].valid
                    "
                    >{{ 'appraisal_form_door' | translate }}</label
                  >
                  <input
                    id="appraisal-form-door"
                    type="text"
                    formControlName="door"
                    [maxlength]="HTML_VALIDATORS?.maxLength?.doorway"
                  />
                  <div class="error-content">
                    @if ((appraisalForm?.controls)['door'].touched && (appraisalForm?.controls)['door'].invalid) {
                      <p class="has-error">
                        {{ 'appraisal_form_invalid_door' | translate }}
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 no-pd">
              <div class="input-box">
                <label
                  for="appraisal-form-location"
                  [class.has-error]="
                    (appraisalForm?.controls)['location']?.touched && !(appraisalForm?.controls)['location'].valid
                  "
                  >{{ 'appraisal_form_location' | translate }}</label
                >
                <input
                  id="appraisal-form-location"
                  type="text"
                  formControlName="location"
                  appOnlyLetters
                  [maxlength]="HTML_VALIDATORS.maxLength.cityName"
                />
                <div class="error-content">
                  @if (
                    (appraisalForm?.controls)['location'].touched &&
                    appraisalForm?.controls['location'].hasError('required')
                  ) {
                    <p class="has-error">
                      {{ 'hipotecas_error_required' | translate }}
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="input-box">
              <label
                for="appraisal-form-street"
                [class.has-error]="
                  (appraisalForm?.controls)['street']?.touched && !(appraisalForm?.controls)['street'].valid
                "
                >{{ 'appraisal_form_street' | translate }}</label
              >
              <input
                id="appraisal-form-street"
                type="text"
                appOnlyLetters
                formControlName="street"
                [maxlength]="HTML_VALIDATORS.maxLength.roadName"
              />
              <div class="error-content">
                @if (
                  (appraisalForm?.controls)['street'].touched && appraisalForm?.controls['street'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
            <div class="input-box">
              <label
                for="appraisal-form-postalCode"
                [class.has-error]="
                  (appraisalForm?.controls)['postalCode']?.touched && !(appraisalForm?.controls)['postalCode'].valid
                "
                >{{ 'appraisal_form_postal_code' | translate }}</label
              >
              <input
                id="appraisal-form-postalCode"
                type="text"
                maxlength="5"
                minlength="5"
                formControlName="postalCode"
              />
              <div class="error-content">
                @if (
                  (appraisalForm?.controls)['postalCode'].touched &&
                  appraisalForm?.controls['postalCode'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }

                @if (
                  (appraisalForm?.controls)['postalCode'].touched &&
                  appraisalForm?.controls['postalCode'].hasError('pattern')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_postal_code' | translate }}
                  </p>
                }

                @if (
                  (appraisalForm?.controls)['postalCode'].touched &&
                  appraisalForm?.controls['postalCode'].hasError('noValidPostalCode')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_postal_code_unauthorized' | translate }}
                  </p>
                }
              </div>
            </div>
            <div class="input-box">
              <label
                for="appraisal-form-province"
                [class.has-error]="
                  (appraisalForm?.controls)['province']?.touched && !(appraisalForm?.controls)['province'].valid
                "
                >{{ 'appraisal_form_province' | translate }}</label
              >
              <select id="appraisal-form-province" formControlName="province">
                <option *ngFor="let item of listCCAA" [value]="item?.id">
                  {{ item.name }}
                </option>
              </select>
              <div class="error-content">
                @if (
                  (appraisalForm?.controls)['province'].touched &&
                  appraisalForm?.controls['province'].hasError('required')
                ) {
                  <p class="has-error">
                    {{ 'hipotecas_error_required' | translate }}
                  </p>
                }
              </div>
            </div>
          </div>
          <div class="col-12 appraisal-ref">
            <div class="alert alert-info document-info margin-top-10">
              <p>
                <span class="uppercase">Importante: </span>Si vas a hipotecar también plaza de garaje y / o trastero,
                añádelos con su propia referencia catastral. Si no la tienes ahora, escribe “desconocido” en cada una de
                ellas para continuar.
              </p>
            </div>

            <p class="info-text">
              {{ 'appraisal_form_appraisal_ref' | translate }}
              <a class="icon-a" (click)="openModal('catastral')">
                <img class="ico-info" src="assets/img/info.png" />
              </a>
            </p>
            <div formArrayName="catastralRefs">
              <!-- controlar aqui la clave para indicar qué referencia se esta añadiendo -->
              <div *ngFor="let catastral of (appraisalForm?.controls)['catastralRefs']?.controls; let i = index">
                <p [innerHTML]="'catastral_ref_title' | translate: { ordinal: 'ordinal_' + (i + 1) | translate }"></p>
                <div class="row" [formGroup]="catastral">
                  <div class="col-md-6 col-12">
                    <div class="textarea-box">
                      <label
                        [for]="'appraisal-form-reference-' + i"
                        [class.has-error]="
                          (catastral?.controls)['reference']?.touched && !(catastral?.controls)['reference'].valid
                        "
                        >{{ 'appraisal_form_appraisal_ref_title' | translate }}
                      </label>
                      <input
                        [id]="'appraisal-form-reference-' + i"
                        type="text"
                        formControlName="reference"
                        [maxlength]="HTML_VALIDATORS?.maxLength?.reference"
                      />
                      <div class="error-content">
                        @if (
                          (catastral?.controls)['reference'].touched &&
                          catastral?.controls['reference'].hasError('required')
                        ) {
                          <p class="has-error">
                            {{ 'hipotecas_error_required' | translate }}
                          </p>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-12">
                    <div class="input-box">
                      <label
                        [for]="'appraisal-form-typeAsset-' + i"
                        [class.has-error]="
                          (catastral?.controls)['typeAsset']?.touched && !(catastral?.controls)['typeAsset'].valid
                        "
                        >{{ 'appraisal_form_property_type' | translate }}</label
                      >
                      <select formControlName="typeAsset" [id]="'appraisal-form-typeAsset-' + i">
                        <option *ngFor="let item of listApprTypeAssets$ | async" [value]="item?.value">
                          {{ 'APPR_TYPE_ASSETS_' + item?.value | translate }}
                        </option>
                      </select>
                      <div class="error-content">
                        @if (
                          (catastral?.controls)['typeAsset'].touched &&
                          catastral?.controls['typeAsset'].hasError('required')
                        ) {
                          <p class="has-error">
                            {{ 'hipotecas_error_required' | translate }}
                          </p>
                        }
                      </div>
                    </div>
                  </div>

                  <div class="property-registry-content" [formGroup]="catastral?.get('propertyRegistry')">
                    <div class="col-md-6 col-12">
                      <div class="textarea-box">
                        <label
                          [for]="'appraisal-form-registry-' + i"
                          [class.has-error]="
                            (catastral?.controls)['registry']?.touched && !(catastral?.controls)['registry']?.valid
                          "
                        >
                          {{ 'appraisal_label_registry' | translate }}
                        </label>
                        <!-- <input
                          [id]="'appraisal-form-registry-' + i"
                          type="text"
                          formControlName="registry"
                          [maxlength]="HTML_VALIDATORS?.maxLength?.registry"
                        /> -->
                        <select formControlName="registry" [id]="'appraisal-form-registry-' + i">
                          <option *ngFor="let item of listApprRegistry$ | async" [value]="item?.value">
                            {{ 'APPR_REGISTRY_' + item?.value | translate }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="textarea-box">
                        <label
                          [for]="'appraisal-form-registryNumber-' + i"
                          [class.has-error]="
                            (catastral?.controls)['registryNumber']?.touched &&
                            !(catastral?.controls)['registryNumber']?.valid
                          "
                        >
                          {{ 'appraisal_label_registry_number' | translate }}
                        </label>
                        <input
                          [id]="'appraisal-form-registryNumber-' + i"
                          type="text"
                          formControlName="registryNumber"
                          [maxlength]="HTML_VALIDATORS?.maxLength?.registryNumber"
                        />
                      </div>
                    </div>
                    <div class="col-md-3 col-12">
                      <div class="textarea-box">
                        <label
                          [for]="'appraisal-form-farmNumber-' + i"
                          [class.has-error]="
                            (catastral?.controls)['farmNumber']?.touched && !(catastral?.controls)['farmNumber']?.valid
                          "
                        >
                          {{ 'appraisal_label_farm_number' | translate }}
                        </label>
                        <input
                          [id]="'appraisal-form-farmNumber-' + i"
                          type="text"
                          formControlName="farmNumber"
                          [maxlength]="HTML_VALIDATORS?.maxLength?.farmNumber"
                        />
                      </div>
                    </div>

                    <div class="col-md-6 col-12">
                      <div class="row">
                        <div class="col-4">
                          <div class="textarea-box">
                            <label
                              [for]="'appraisal-form-volume-' + i"
                              [class.has-error]="
                                (catastral?.controls)['volume']?.touched && !(catastral?.controls)['volume']?.valid
                              "
                            >
                              {{ 'appraisal_label_volume' | translate }}
                            </label>
                            <input
                              [id]="'appraisal-form-volume-' + i"
                              type="text"
                              formControlName="volume"
                              [maxlength]="HTML_VALIDATORS?.maxLength?.volume"
                            />
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="textarea-box">
                            <label
                              [for]="'appraisal-form-book-' + i"
                              [class.has-error]="
                                (catastral?.controls)['book']?.touched && !(catastral?.controls)['book']?.valid
                              "
                            >
                              {{ 'appraisal_label_book' | translate }}
                            </label>
                            <input
                              [id]="'appraisal-form-book-' + i"
                              type="text"
                              formControlName="book"
                              [maxlength]="HTML_VALIDATORS?.maxLength?.book"
                            />
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="textarea-box">
                            <label
                              [for]="'appraisal-form-folio-' + i"
                              [class.has-error]="
                                (catastral?.controls)['folio']?.touched && !(catastral?.controls)['folio']?.valid
                              "
                            >
                              {{ 'appraisal_label_folio' | translate }}
                            </label>
                            <input
                              [id]="'appraisal-form-folio-' + i"
                              type="text"
                              formControlName="folio"
                              [maxlength]="HTML_VALIDATORS?.maxLength?.folio"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6 col-12" [formGroup]="catastral">
                      <div class="textarea-box">
                        <label
                          [for]="'appraisal-form-idufir-' + i"
                          [class.has-error]="
                            (catastral?.controls)['idufir']?.touched && !(catastral?.controls)['idufir']?.valid
                          "
                          >{{ 'appraisal_label_idufir' | translate }}
                        </label>
                        <input
                          [id]="'appraisal-form-idufir-' + i"
                          type="text"
                          formControlName="idufir"
                          [maxlength]="HTML_VALIDATORS?.maxLength?.idufir"
                        />
                      </div>
                      @if ((appraisalForm?.controls)['catastralRefs']?.length > 1) {
                        <button (click)="deleteReference(i)" class="btn btn-03" type="button">
                          {{ 'appraisal_form_remove_ref' | translate }}
                        </button>
                      }
                    </div>
                  </div>
                </div>
                <hr class="divider btn-divider" />
              </div>
              <div class="col-12 no-pd">
                <button
                  [disabled]="appraisalForm?.get('catastralRefs')?.length >= 10"
                  id="appraisal-form-btn-add-reference"
                  (click)="addReference()"
                  class="btn btn-03"
                  type="button"
                >
                  {{ 'appraisal_form_add_ref' | translate }}
                </button>
              </div>
            </div>
          </div>

          <div class="col-12" [ngClass]="{ disabled: hasAppraisal }">
            <div class="date-row row">
              <p class="h-sub-section col-12">
                {{ 'appraisal_form_data_current_owner' | translate }}
                <a class="icon-a" id="appraisal-form-btn-info-current-owner" (click)="openModal('contact')">
                  <img class="ico-info" src="assets/img/info.png" />
                </a>
              </p>
              <div class="col-md-6 col-12">
                <div class="input-box">
                  <label
                    for="appraisal-form-name-owner"
                    [class.has-error]="
                      (appraisalForm?.controls)['name']?.touched && !(appraisalForm?.controls)['name'].valid
                    "
                    >{{ 'appraisal_form_name' | translate }}</label
                  >
                  <input
                    id="appraisal-form-name-owner"
                    type="text"
                    formControlName="name"
                    appOnlyLetters
                    [maxlength]="HTML_VALIDATORS.maxLength.ownerName"
                  />
                  <div class="error-content">
                    @if (
                      (appraisalForm?.controls)['name'].touched && appraisalForm?.controls['name'].hasError('required')
                    ) {
                      <p class="has-error">
                        {{ 'hipotecas_error_required' | translate }}
                      </p>
                    }
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="input-box">
                  <label
                    for="appraisal-form-phone-owner"
                    [class.has-error]="
                      (appraisalForm?.controls)['phone']?.touched && !(appraisalForm?.controls)['phone'].valid
                    "
                    >{{ 'appraisal_form_phone' | translate }}</label
                  >
                  <input
                    id="appraisal-form-phone-owner"
                    type="tel"
                    formControlName="phone"
                    appOnlyNumbers
                    maxlength="9"
                  />
                  <div class="error-content">
                    @if (
                      (appraisalForm?.controls)['phone'].touched &&
                      appraisalForm?.controls['phone'].hasError('required')
                    ) {
                      <p class="has-error">
                        {{ 'hipotecas_error_required' | translate }}
                      </p>
                    }

                    @if (
                      (appraisalForm?.controls)['phone'].touched && appraisalForm?.controls['phone'].hasError('pattern')
                    ) {
                      <p class="has-error">
                        {{ 'hipotecas_error_invalid_format_phone' | translate }}
                      </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
  </div>
</div>
